import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";

import { cn } from "../../utils";

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    role="group"
    aria-label="Slider"
    className={cn(
      "al-relative al-flex al-w-full al-touch-none al-select-none al-items-center",
      className
    )}
    {...props}
  >
    <SliderPrimitive.Track
      role="presentation"
      aria-label="Slider track"
      className="al-relative al-h-2 al-w-full al-grow al-overflow-hidden al-rounded-full al-bg-secondary"
    >
      <SliderPrimitive.Range className="al-absolute al-h-full al-bg-primary" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb className="al-block al-h-5 al-w-5 al-rounded-full al-border-2 al-border-primary al-bg-background al-ring-offset-background al-transition-colors focus-visible:al-outline-none focus-visible:al-ring-2 focus-visible:al-ring-ring focus-visible:al-ring-offset-2 disabled:al-pointer-events-none disabled:al-opacity-50" />
  </SliderPrimitive.Root>
));
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
